import { t } from 'i18next'
import { HomeIcon } from '@heroicons/react/24/solid'

import { env } from '@authy/lib-client/env'

import { AdminAppState } from '@/appState/AdminAppState'

import { Application } from './types'

type BaseApplication = Omit<Application, 'url' | 'name' | 'description'> & {
    getUrl: (tenantShortId: string) => string
}

const baseApplications: BaseApplication[] = [
    {
        key: 'root',
        group: 'main',
        getUrl: (tenantShortId) => `${env.VITE_PRODUCT_URL_ROOT}/${tenantShortId}`,
        bgColorClassName: 'bg-amber-500 text-white',
        textColorClassName: 'text-amber-700',
        hoverTextColorClassName: 'hover:text-amber-500',
        Icon: HomeIcon,
        permissions: [],
    },
]

export const getApplications = (
    appState: AdminAppState,
    { ignorePermissions }: { ignorePermissions: boolean }
): Application[] => {
    const result: Application[] = []

    const { language, tenant } = appState

    baseApplications
        .filter((baseApp) => appState.showUpcomingFeatures || ['root', 'admin'].includes(baseApp.key))
        .forEach((baseApp) => {
            const {
                key,
                group,
                getUrl,
                permissions,
                bgColorClassName,
                textColorClassName,
                hoverTextColorClassName,
                Icon,
            } = baseApp

            const hasAnyPermission =
                ignorePermissions ||
                permissions.length === 0 ||
                permissions.filter((permission) => appState.hasTenantPermissions(permission, false)).length > 0

            if (hasAnyPermission) {
                result.push({
                    key,
                    group,
                    url: tenant ? getUrl(tenant.shortId) : '',
                    name: t(`app.applications.${key}.name`, { lng: language }),
                    description: t(`app.applications.${key}.description`, { lng: language }),
                    bgColorClassName,
                    textColorClassName,
                    hoverTextColorClassName,
                    Icon,
                    permissions,
                })
            }
        })

    return result
}
